export default [
  {
    label: '1 - 24',
    value: '1_24'
  },
  {
    label: '25 - 48',
    value: '25_48'
  },
  {
    label: '49 - 72',
    value: '49_72'
  },
  {
    label: '73 - 96',
    value: '73_96'
  },
  {
    label: '97 - 120',
    value: '97_120'
  },
  {
    label: '121 - 144',
    value: '121_144'
  },
  {
    label: '145 - 168',
    value: '145_168'
  },
  {
    label: '169 - 192',
    value: '169_192'
  },
  {
    label: '193 - 216',
    value: '193_216'
  },
  {
    label: '217 - 240',
    value: '217_240'
  },
  {
    label: '241 - 264',
    value: '241_264'
  },
  {
    label: '265 - 288',
    value: '265_288'
  },
  {
    label: '289 - 312',
    value: '289_312'
  },
  {
    label: '313 - 336',
    value: '313_336'
  },
  {
    label: '337 - 360',
    value: '337_360'
  },
  {
    label: '361 - 384',
    value: '361_384'
  },
  {
    label: '385 - 408',
    value: '385_408'
  },
  {
    label: '409 - 432',
    value: '409_432'
  },
  {
    label: '433 - 456',
    value: '433_456'
  },
  {
    label: '457 - 480',
    value: '457_480'
  },
  {
    label: '481 - 504',
    value: '481_504'
  },
  {
    label: '505 - 528',
    value: '505_528'
  },
  {
    label: '529 - 552',
    value: '529_552'
  },
  {
    label: '553 - 576',
    value: '553_576'
  },
  {
    label: '577 - 600',
    value: '577_600'
  },
  {
    label: '601 - 624',
    value: '601_624'
  },
  {
    label: '625 - 648',
    value: '625_648'
  },
  {
    label: '649 - 672',
    value: '649_672'
  },
  {
    label: '673 - 696',
    value: '673_696'
  },
  {
    label: '697 - 720',
    value: '697_720'
  },
  {
    label: '721 - 744',
    value: '721_744'
  },
  {
    label: '745 - 768',
    value: '745_768'
  },
  {
    label: '769 - 792',
    value: '769_792'
  },
  {
    label: '793 - 816',
    value: '793_816'
  },
  {
    label: '817 - 840',
    value: '817_840'
  },
  {
    label: '841 - 864',
    value: '841_864'
  },
  {
    label: '865 - 888',
    value: '865_888'
  },
  {
    label: '889 - 912',
    value: '889_912'
  },
  {
    label: '913 - 936',
    value: '913_936'
  },
  {
    label: '937 - 960',
    value: '937_960'
  },
  {
    label: '961 - 984',
    value: '961_984'
  },
  {
    label: '985 - 1008',
    value: '985_1008'
  },
  {
    label: '1009 - 1032',
    value: '1009_1032'
  },
  {
    label: '1033 - 1056',
    value: '1033_1056'
  },
  {
    label: '1057 - 1080',
    value: '1057_1080'
  },
  {
    label: '1081 - 1104',
    value: '1081_1104'
  },
  {
    label: '1105 - 1128',
    value: '1105_1128'
  },
  {
    label: '1129 - 1152',
    value: '1129_1152'
  },
  {
    label: '1153 - 1176',
    value: '1153_1176'
  },
  {
    label: '1177 - 1200',
    value: '1177_1200'
  },
  {
    label: '1201 - 1224',
    value: '1201_1224'
  },
  {
    label: '1225 - 1248',
    value: '1225_1248'
  },
  {
    label: '1249 - 1272',
    value: '1249_1272'
  },
  {
    label: '1273 - 1296',
    value: '1273_1296'
  },
  {
    label: '1297 - 1320',
    value: '1297_1320'
  },
  {
    label: '1321 - 1344',
    value: '1321_1344'
  },
  {
    label: '1345 - 1368',
    value: '1345_1368'
  },
  {
    label: '1369 - 1392',
    value: '1369_1392'
  },
  {
    label: '1393 - 1416',
    value: '1393_1416'
  },
  {
    label: '1417 - 1440',
    value: '1417_1440'
  },
  {
    label: '1441 - 1464',
    value: '1441_1464'
  },
  {
    label: '1465 - 1488',
    value: '1465_1488'
  },
  {
    label: '1489 - 1512',
    value: '1489_1512'
  },
  {
    label: '1513 - 1536',
    value: '1513_1536'
  },
  {
    label: '1537 - 1560',
    value: '1537_1560'
  },
  {
    label: '1561 - 1584',
    value: '1561_1584'
  },
  {
    label: '1585 - 1608',
    value: '1585_1608'
  },
  {
    label: '1609 - 1632',
    value: '1609_1632'
  },
  {
    label: '1633 - 1656',
    value: '1633_1656'
  },
  {
    label: '1657 - 1680',
    value: '1657_1680'
  },
  {
    label: '1681 - 1704',
    value: '1681_1704'
  },
  {
    label: '1705 - 1728',
    value: '1705_1728'
  },
  {
    label: '1729 - 1752',
    value: '1729_1752'
  },
  {
    label: '1753 - 1776',
    value: '1753_1776'
  },
  {
    label: '1777 - 1800',
    value: '1777_1800'
  },
  {
    label: '1801 - 1824',
    value: '1801_1824'
  },
  {
    label: '1825 - 1848',
    value: '1825_1848'
  },
  {
    label: '1849 - 1872',
    value: '1849_1872'
  },
  {
    label: '1873 - 1896',
    value: '1873_1896'
  },
  {
    label: '1897 - 1920',
    value: '1897_1920'
  },
  {
    label: '1921 - 1944',
    value: '1921_1944'
  },
  {
    label: '1945 - 1968',
    value: '1945_1968'
  },
  {
    label: '1969 - 1992',
    value: '1969_1992'
  },
  {
    label: '1993 - 2016',
    value: '1993_2016'
  },
  {
    label: '2017 - 2040',
    value: '2017_2040'
  },
  {
    label: '2041 - 2064',
    value: '2041_2064'
  },
  {
    label: '2065 - 2088',
    value: '2065_2088'
  },
  {
    label: '2089 - 2112',
    value: '2089_2112'
  },
  {
    label: '2113 - 2136',
    value: '2113_2136'
  },
  {
    label: '2137 - 2160',
    value: '2137_2160'
  },
  {
    label: '2161 - 2184',
    value: '2161_2184'
  },
  {
    label: '2185 - 2208',
    value: '2185_2208'
  },
  {
    label: '2209 - 2232',
    value: '2209_2232'
  },
  {
    label: '2233 - 2256',
    value: '2233_2256'
  },
  {
    label: '2257 - 2280',
    value: '2257_2280'
  },
  {
    label: '2281 - 2304',
    value: '2281_2304'
  },
  {
    label: '2305 - 2328',
    value: '2305_2328'
  },
  {
    label: '2329 - 2352',
    value: '2329_2352'
  },
  {
    label: '2353 - 2376',
    value: '2353_2376'
  },
  {
    label: '2377 - 2400',
    value: '2377_2400'
  }
];
